function parseBoolean(value, fallback = false) {
  if (value === undefined || value === null || value === "") return fallback;
  const normalized = String(value).trim().toLowerCase();
  if (["1", "true", "yes", "on"].includes(normalized)) return true;
  if (["0", "false", "no", "off"].includes(normalized)) return false;
  return fallback;
}

function parseNumber(value, fallback) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

function normalizeAppEnv(raw) {
  const value = String(raw || "").trim().toLowerCase();
  if (["production", "prod"].includes(value)) return "prod";
  if (["staging", "stage", "preprod", "preview"].includes(value)) return "staging";
  return "dev";
}

const appEnv = normalizeAppEnv(process.env.REACT_APP_APP_ENV || process.env.NODE_ENV);

export const analyticsConfig = Object.freeze({
  appEnv,
  enabled: parseBoolean(process.env.REACT_APP_ENABLE_ANALYTICS, true),
  provider: String(process.env.REACT_APP_ANALYTICS_PROVIDER || "ga4").trim().toLowerCase(),
  gaMeasurementId: String(process.env.REACT_APP_GA_MEASUREMENT_ID || "G-24JP1PXSGP").trim(),
  debug: parseBoolean(process.env.REACT_APP_ANALYTICS_DEBUG, appEnv !== "prod"),
  eventSchemaVersion: String(process.env.REACT_APP_ANALYTICS_EVENT_SCHEMA_VERSION || "2026-02-22").trim(),
  maxBufferedEvents: Math.max(20, parseNumber(process.env.REACT_APP_ANALYTICS_BUFFER_SIZE, 120)),
});

export const adsConfig = Object.freeze({
  enabled: parseBoolean(process.env.REACT_APP_ENABLE_ADS, false),
  provider: String(process.env.REACT_APP_ADS_PROVIDER || "house").trim().toLowerCase(),
  placements: Object.freeze({
    dashboard: parseBoolean(process.env.REACT_APP_AD_SLOT_DASHBOARD, false),
    gameDetail: parseBoolean(process.env.REACT_APP_AD_SLOT_GAME_DETAIL, false),
    news: parseBoolean(process.env.REACT_APP_AD_SLOT_NEWS, false),
  }),
});

export const telemetryConfig = Object.freeze({
  enabled: parseBoolean(process.env.REACT_APP_ENABLE_TELEMETRY, true),
  captureRuntimeErrors: parseBoolean(process.env.REACT_APP_TELEMETRY_ERRORS, true),
  captureWebVitals: parseBoolean(process.env.REACT_APP_TELEMETRY_WEB_VITALS, appEnv !== "dev"),
  captureApiMetrics: parseBoolean(process.env.REACT_APP_TELEMETRY_API, true),
  slowApiThresholdMs: Math.max(250, parseNumber(process.env.REACT_APP_TELEMETRY_API_SLOW_MS, 1200)),
  maxBufferedEvents: Math.max(50, parseNumber(process.env.REACT_APP_TELEMETRY_BUFFER_SIZE, 200)),
});
